module.exports = __webpack_public_path__ + "img/gameart.6e50523b.svg";